import * as tslib_1 from "tslib";
import React from 'react';
import { injectGlobal } from 'sinoui-components/styles';
import classNames from 'classnames';
import Textarea from 'react-textarea-autosize';
// tslint:disable-next-line:no-unused-expression
injectGlobal(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  .sinoui-selectable__textarea {\n    resize: none;\n    overflow: auto;\n    padding: 6px 0;\n  }\n"], ["\n  .sinoui-selectable__textarea {\n    resize: none;\n    overflow: auto;\n    padding: 6px 0;\n  }\n"])));
/**
 * 输入框
 *
 * @export
 * @param {Props} props
 */
export default function Input(props) {
    var InputComp = props.multiline ? Textarea : 'input';
    var className = props.multiline ? 'sinoui-selectable__textarea' : '';
    return (React.createElement(InputComp, tslib_1.__assign({ type: "text" }, props, { className: classNames(className, props.className) })));
}
var templateObject_1;
//# sourceMappingURL=Input.js.map